// frontend/src/components/wizard/StepMapping/DedupPanel.jsx
import React from 'react';
import { Layers } from 'lucide-react';
import { useLanguageStore } from '../../../store/useLanguageStore';

export const DedupPanel = ({ dedupConfig, setDedupConfig, sourceColumns }) => {
  const { t } = useLanguageStore();

  return (
    <div className="mt-6 bg-slate-50 border border-slate-200 p-4 rounded-xl flex flex-col md:flex-row items-start md:items-center justify-between shadow-sm">
      <div>
        <h4 className="font-bold text-slate-800 flex items-center">
          <Layers className="w-4 h-4 mr-2 text-indigo-600" /> {t('wizard.mapping.dedup_title') || 'Control de Duplicados'}
        </h4>
        <p className="text-xs text-slate-500 mt-1">
          {t('wizard.mapping.dedup_desc') || 'El Worker ETL usará la memoria RAM para descartar registros repetidos al vuelo.'}
        </p>
      </div>
      <div className="flex items-center justify-end w-full md:w-auto mt-3 md:mt-0 gap-3">
        <label className="text-sm font-semibold text-slate-700">{t('wizard.mapping.avoid_dedup') || 'Evitar duplicados:'}</label>
        <input
          type="checkbox"
          checked={dedupConfig.enabled}
          onChange={(e) => setDedupConfig(prev => ({ ...prev, enabled: e.target.checked }))}
          className="w-5 h-5 rounded border-slate-300 text-indigo-600 focus:ring-indigo-600 cursor-pointer"
        />
        {dedupConfig.enabled && (
          <select
            className="text-sm border-slate-300 rounded-lg p-2 focus:ring-indigo-500 outline-none shadow-sm max-w-[150px] md:max-w-xs"
            value={dedupConfig.column}
            onChange={(e) => setDedupConfig(prev => ({ ...prev, column: e.target.value }))}
          >
            <option value="">{t('wizard.mapping.column_placeholder') || '-- Columna --'}</option>
            {sourceColumns.map(colObj => <option key={colObj.name} value={colObj.name}>{colObj.name}</option>)}
          </select>
        )}
      </div>
    </div>
  );
};